/**
 * @fileoverview Agent definition for storyline-ideation-v1.
 *
 * Generates a single new storyline (with beats and story questions) to add
 * to an existing story. The user provides guidance text and a priority
 * (A/B/C), and the agent produces a complete storyline that complements
 * the existing storylines.
 *
 * Unlike storylines-planner-v1 (which architects ALL storylines from scratch),
 * this agent creates ONE storyline to add to an in-progress story.
 *
 * @category narrative.story.plot
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'storyline-ideation-v1',
  kind: 'primitive',
  name: 'Storyline Ideation',
  description: 'Generates a single new storyline with beats and story questions based on user guidance and priority. Designed for adding a storyline to an existing story.',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.story.plot',
    usedBy: [],
    relatedAgents: ['storylines-planner-v1', 'plot-ideas-generator-v2'],
  },
  recommendedModels: [
    { modelProvider: 'anthropic', modelName: 'claude-opus-4-5' },
    { modelProvider: 'google-ai', modelName: 'gemini-3.1-pro-preview' },
    { modelProvider: 'openai', modelName: 'gpt-5.2' },
  ],
};
